import { render, staticRenderFns } from "./Rol.vue?vue&type=template&id=49c64b6f&scoped=true"
import script from "./Rol.vue?vue&type=script&lang=js"
export * from "./Rol.vue?vue&type=script&lang=js"
import style0 from "./Rol.vue?vue&type=style&index=0&id=49c64b6f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c64b6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49c64b6f')) {
      api.createRecord('49c64b6f', component.options)
    } else {
      api.reload('49c64b6f', component.options)
    }
    module.hot.accept("./Rol.vue?vue&type=template&id=49c64b6f&scoped=true", function () {
      api.rerender('49c64b6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Rol.vue"
export default component.exports